/* Sección 3 de la PDP: flechas del carrusel de testimoniales.
   El deslizamiento táctil es scroll-snap nativo; esto sólo mueve la pista una
   tarjeta por clic en escritorio. Asignación directa de scrollLeft, no scroll
   suave: con scroll-snap-stop en la pista, el navegador puede bloquear un
   desplazamiento suave programático (lección del carrusel principal). */

(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ptcInit === '1') return;
    root.dataset.ptcInit = '1';

    var track = root.querySelector('[data-testimonials-track]');
    var prev = root.querySelector('[data-testimonials-prev]');
    var next = root.querySelector('[data-testimonials-next]');
    if (!track) return;

    /* Bolitas de posición (opción B de Mau, sesión 7): una por tarjeta,
       la activa se estira en píldora. Se generan aquí para que nunca
       descuadren con el número real de tarjetas. */
    var dotsWrap = root.querySelector('[data-testimonials-dots]');
    var dots = [];
    if (dotsWrap) {
      var cardCount = track.querySelectorAll('.ptc__card').length;
      for (var di = 0; di < cardCount; di++) {
        var dot = document.createElement('span');
        dot.className = 'ptc__dot';
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function syncDots() {
      if (!dots.length) return;
      var idx = Math.round(track.scrollLeft / cardStep());
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('ptc__dot--on', i === idx);
      }
    }

    function cardStep() {
      var cards = track.querySelectorAll('.ptc__card');
      if (cards.length < 2) return track.clientWidth;
      return cards[1].offsetLeft - cards[0].offsetLeft;
    }

    function jump(direction) {
      var previous = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft += direction * cardStep();
      track.style.scrollBehavior = previous;
      /* syncUI y no solo flechas: así las bolitas responden al clic sin
         esperar al evento scroll (que además el pane de QA no emite en
         cambios programáticos — en navegador real sí llega). */
      syncUI();
    }

    function syncArrows() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { jump(-1); });
    if (next) next.addEventListener('click', function () { jump(1); });

    function syncUI() {
      syncArrows();
      syncDots();
    }

    track.addEventListener('scroll', syncUI, { passive: true });
    window.addEventListener('resize', syncUI);
    syncUI();

    /* La rueda del ratón se probó y se QUITÓ (Mau, sesión 7): en
       escritorio los testimoniales se mueven SOLO con las flechas.
       En móvil el deslizamiento táctil nativo sigue intacto. */

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        jump(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        jump(-1);
      }
    });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-testimonials]');
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
